import { useState } from 'react';

export const GRAPH_TYPE = {
  DEFAULT: 'default',
  LINE: 'line',
  BAR: 'bar',
} as const;

export type GraphTypeValue = (typeof GRAPH_TYPE)[keyof typeof GRAPH_TYPE];

export const useChartType = () => {
  const [selectedGraphType, setSelectedGraphType] = useState<GraphTypeValue>(GRAPH_TYPE.DEFAULT);
  return { selectedGraphType, setSelectedGraphType };
};
